module.exports = __webpack_public_path__ + "img/actionorange.60e3ead9.svg";